import { getWebinarDesign, useWebinarDesignQuery } from './useWebinarDesign'

const useRoomDesign = () => {
  const { data: webinarDesign } = useWebinarDesignQuery()

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return webinarDesign?.designData?.['room-settings']
}

const useStandardLayouts = () => {
  const { data: webinarDesign } = useWebinarDesignQuery()

  return webinarDesign?.designData['standard-layouts']
}

const getStandardLayouts = () =>
  getWebinarDesign()?.designData['standard-layouts']

const useCustomLayouts = () => {
  const { data: webinarDesign } = useWebinarDesignQuery()

  return webinarDesign?.designData['custom-layouts']
}

export {
  useRoomDesign,
  useStandardLayouts,
  getStandardLayouts,
  useCustomLayouts,
}
